import React, { FC } from 'react';

import { NOTCH_DEPTH as DEPTH, NOTCH_SMOOTH as SMOOTH, NOTCH_SPREAD as SPREAD } from '../constants';

interface INavigationNotchBackground {
  centerX: number;
  height: number;
  width: number;
}

const NavigationNotchBackground: FC<INavigationNotchBackground> = ({ centerX, height, width }) => {
  if (!width || !height) {
    return null;
  }

  const cx = centerX;
  const control = SPREAD * SMOOTH;

  const left = Math.max(0, cx - SPREAD);
  const right = Math.min(width, cx + SPREAD);

  const path = [
    `M0 0`,
    `H${left}`,
    `C${cx - control} 0 ${cx - control} ${DEPTH} ${cx} ${DEPTH}`,
    `C${cx + control} ${DEPTH} ${cx + control} 0 ${right} 0`,
    `H${width}`,
    `V${height}`,
    `H0`,
    `Z`,
  ].join(' ');

  return (
    <svg
      aria-hidden="true"
      className="navigation-notch-bg"
      height={height}
      preserveAspectRatio="none"
      viewBox={`0 0 ${width} ${height}`}
      width={width}
    >
      <path d={path} />
    </svg>
  );
};

export default NavigationNotchBackground;
